import { render, staticRenderFns } from "./fccMensagensEmail.vue?vue&type=template&id=7c5310c3"
import script from "./fccMensagensEmail.vue?vue&type=script&lang=js"
export * from "./fccMensagensEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports